<template>
  <div>
    <splide
      :options="options"
      @splide:move="onMove"
    >
      <splide-slide v-for="i in (items.length / 2)" :key="i">
        <div class="item">
          <slot :name="(i-1)*2" />
          <slot :name="(i-1)*2+1" />
        </div>
      </splide-slide>
    </splide>
  </div>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

  export default {
    components: {
      Splide,
      SplideSlide,
    },

    props: {
      items: { type: Array, required: true }
    },

    computed: {
      options () {
        return {
          type: 'loop',
          autoWidth: true,
          pagination: false,
          focus: 'center',
        }
      }
    },

    methods: {
      onMove () {
        this.$emit('move')
      }
    }
  }
</script>

<style scoped lang="scss">
  .item {
    position: relative;

    ::v-deep > *:nth-child(2) {
      margin: 2.5rem 0 1.5625rem 2.5rem;
    }

    @media (max-width: 550px) {
      ::v-deep > *:nth-child(2) {
        margin-left: 30px;
      }
    }
  }

  ::v-deep .splide__arrow {
    opacity: 1;
    background: linear-gradient(90deg, #FF7300 -3.33%, #FF5C00 100%);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 5px 5px 30px rgba(0, 0, 0, 0.2);
    width: 45px;
    height: 88px;
    border-radius: 5px;

    svg { fill: #fff }

    @media(max-width: 550px) { display: none }
  }
  
</style>